<template>

<app-table-cell class="colour" :style="{backgroundColor: hex}">
    
</app-table-cell>
    
</template>
    
<script>
    
export default {
    
    props: ['colour'],

    computed: {
    
        hex: function() {
        
            return (this.colour.indexOf('#') === 0) ? this.colour : '#' + this.colour
        
        }

    }
    
}
    
</script>
    
<style scoped>
    
.colour {
    border-radius: 4px;
}
    
</style>